export default __webpack_public_path__ + "static/media/external-link.90577cce.svg";